window.Products.Clothing.FittedSkirt = function() {
};
window.Products.Clothing.FittedSkirt.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.FittedSkirt.id = 17;
window.Products.Clothing.FittedSkirt.slug = 'fitted-skirt';
window.Products.Clothing.FittedSkirt.has_3d = true;
window.Products.Clothing.FittedSkirt.dpi = 150;

window.Products.Clothing.FittedSkirt.prototype.set3dProperties = function(modelViewer) {
    this.updateThreeTexture(modelViewer);
    modelViewer.object.position.y = 0.06;
    modelViewer.camera.position.y = 0.5;
    modelViewer.camera.position.z =  1.7;
    modelViewer.initalCameraPosition.z = -1.7;
};

window.Products.Clothing.FittedSkirt.prototype.setThreeControls = function(controls) {
    controls.minDistance = 2.2;
    controls.maxDistance = 2.8;
};

window.Products.Clothing.FittedSkirt.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material[0].map = modelViewer.texture;
    modelViewer.object.children[0].material[1].map = modelViewer.texture;
};